export default __webpack_public_path__ + "static/media/unknown.a43b5fbe.svg";